import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import TrustedClients from "../../components/Trusted-clients-section/TrustedClientsSection";
import { SERVICES_DATA } from "../../model/services_data";
import HeadSection from "../../components/meta";





const Services = () => {
  return (
    <>
      <HeadSection
        title={"SERVICES"}
        keywords={""}
        addPostFixTitle={true}
        largeTwitterCard={true}
        showCanonical={true}
        content={
          "Explore Seed to Tree's services! From beginners to experts, our tailored packages help grow your business. Start your journey with us today!"
        }
        link={`/services`}
      >
        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(courseStructuredData),
          }} 
        >
           */}
      </HeadSection>
      <Header isActive="services" />
      <section id="services" className="services">
        <div className="services__top d-flex justify-content-between align-items-center flex-wrap">
          <div className="services__top__left w-60 community-header">
            <h1>Explore Our Services at Seed to Tree</h1>
            <p>
              From AI solutions to web development, social media marketing, and
              POS systems, we offer expert services to help your business
              thrive. Let’s build success together!
            </p>
          </div>

          <div className="w-50 text-end">
            {/* <button className="btn">See All Services</button> */}
          </div>
        </div>

        {SERVICES_DATA.map((service) => (
          <div
            key={service.id}
            name={service.id}
            className="services__content py-16 px-8"
          >
            <h2 className="text-2xl font-bold mb-4">{service.name}</h2>
            <p className="text-gray-600">{service.description}</p>
          </div>
        ))}
      </section>
      <TrustedClients />
      <Footer />
    </>
  );
};

export default Services;
